import Swiper, { Navigation, Pagination, Scrollbar, Keyboard, Parallax } from 'swiper'

// # main function
sliders()
function sliders() {
  addClassSwiper()

  if (document.querySelector('.slider-programs')) {
    new Swiper('.slider-programs', {
      direction: 'horizontal',
      effect: 'slide',
      loop: false,
      speed: 1000,
      spaceBetween: 10,
      slidesPerView: 'auto',
      // slidesPerGroupAuto: true,
      watchOverflow: true,

      modules: [Navigation, Keyboard],

      navigation: {
        nextEl: '.slider-programs__btn_right',
        prevEl: '.slider-programs__btn_left',
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {
        992.98: {
          spaceBetween: 15,
        },
        1679.98: {
          spaceBetween: 20,
        },
      },
    })
  }
  if (document.querySelector('.slider-collective')) {
    new Swiper('.slider-collective', {
      direction: 'horizontal',
      effect: 'slide',
      loop: false,
      speed: 1000,
      spaceBetween: 0,
      slidesPerView: 'auto',
      // slidesPerGroupAuto: true,
      watchOverflow: true,

      modules: [Keyboard],

      keyboard: {
        enabled: true,
      },
    })
  }
  if (document.querySelector('.slider-team')) {
    new Swiper('.slider-team', {
      direction: 'horizontal',
      effect: 'slide',
      // loop: true,
      speed: 1000,
      spaceBetween: 0,
      slidesPerView: 'auto',
      watchOverflow: true,
      // centerInsufficientSlides: true,
      centeredSlides: true,
      observeParents: true,
      observeSlideChildren: true,
      observer: true,

      modules: [Navigation, Pagination, Scrollbar, Keyboard, Parallax],

      navigation: {
        nextEl: '.team__btn_right',
        prevEl: '.team__btn_left',
      },

      pagination: {
        el: '.team__pagination',
        //# Рядок із типом розбивки на сторінки. Можуть бути 'bullets', 'fraction', 'progressbar' або 'custom'
        type: 'fraction',
        formatFractionCurrent: function (number) {
          return ('0' + number).slice(-2)
        },
        formatFractionTotal: function (number) {
          return ('0' + number).slice(-2)
        },
      },

      //# Якщо нам потрібна смуга прокрутки
      scrollbar: {
        el: '.team__scrollbar',
        draggable: false,
      },

      keyboard: {
        enabled: true,
      },

      parallax: true,
    })
  }
  if (document.querySelector('.slider-why-p')) {
    new Swiper('.slider-why-p', {
      direction: 'horizontal',
      effect: 'slide',
      speed: 1000,
      spaceBetween: 0,
      slidesPerView: 1,
      watchOverflow: true,
      observeParents: true,
      observeSlideChildren: true,
      observer: true,

      modules: [Navigation, Pagination, Keyboard],

      navigation: {
        nextEl: '.why-p__btn_right',
        prevEl: '.why-p__btn_left',
      },

      pagination: {
        el: '.why-p__pagination',
        //# Рядок із типом розбивки на сторінки. Можуть бути 'bullets', 'fraction', 'progressbar' або 'custom'
        type: 'fraction',
        formatFractionCurrent: function (number) {
          return ('0' + number).slice(-2)
        },
        formatFractionTotal: function (number) {
          return ('0' + number).slice(-2)
        },
      },

      keyboard: {
        enabled: true,
      },

      breakpoints: {
        991.98: {
          spaceBetween: 100,
        },
      },
    })
  }
}

//# addClassSwiper
function addClassSwiper() {
  const $sliders = document.querySelectorAll('[class*="__swiper"]')

  $sliders.forEach(slider => {
    slider = slider.parentElement
    const wrapper = slider.children[0]
    const slides = Array.from(wrapper.children)

    slider.classList.add('swiper')
    wrapper.classList.add('swiper-wrapper')
    slides.forEach(addClassSlide)
  })
}

//# addClassSlide
function addClassSlide(slide) {
  slide.classList.add('swiper-slide')
}
